"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateClientFlightDetails = void 0;
const factories_1 = require("../../factories");
const addOrderLog_1 = require("./addOrderLog");
const updateClientFlightDetails = async (supabase, order_line_versions, order_id, variant_id) => {
    let success = true;
    let main_error = null;
    // if there are no provided order_lines we can assume the client has confirmed all tee times as they are
    if (order_line_versions.length > 0) {
        const result = await factories_1.OrderRequestFactory.createOrderLineVersions(supabase, order_line_versions);
        success = result.success;
        if (!success) {
            main_error = result.error;
        }
    }
    if (main_error) {
        throw new Error(main_error.message);
    }
    const { data, error } = await supabase
        .from("order_variants")
        .select("*")
        .eq("id", variant_id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    const variant = data;
    if (!variant.config) {
        variant.config = {
            legs: [],
            tee_times_confirmed: {},
            hotel_bed_options: {},
            airport_transfers_confirmed: {},
            transfer_address_details_confirmed: {},
        };
    }
    order_line_versions.forEach((order_line_version) => {
        if (!variant?.config?.airport_transfers_confirmed) {
            variant.config.airport_transfers_confirmed = {};
        }
        variant.config.airport_transfers_confirmed = {
            ...variant.config.airport_transfers_confirmed,
            [order_line_version.order_line_id]: true,
        };
    });
    await supabase
        .from("order_variants")
        .update({ config: variant.config })
        .eq("id", variant_id);
    await (0, addOrderLog_1.addOrderLog)(supabase, {
        type: "TRANSFER",
        order_id: order_id,
        detail: {
            type: `Client Flight Details`,
            status: null,
            title: "Client Flight Details confirmed",
            message: `${order_line_versions.length} flights have been confirmed`,
        },
    });
};
exports.updateClientFlightDetails = updateClientFlightDetails;
